import { useCallback } from "react";
import { cloneDeep } from "lodash";
import { useFormAPI } from "@/widgets/classic-form/form";
import { useOtherFieldsWithExactnessDisabled } from "../shared/useOtherFieldsWithExactnessDisabled";

export const useToggleOtherFieldExactness = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();
    const fieldsWithExactnessDisabled = useOtherFieldsWithExactnessDisabled();

    return useCallback(
        (newValue: boolean) => {
            const familyValues = getFieldValue("fields");
            const valuesCopy = cloneDeep(familyValues);
            Object.entries(valuesCopy).forEach(([key, field]) => {
                if (!fieldsWithExactnessDisabled.has(key)) {
                    field.isExact = newValue;
                }
            });
            setFieldValue("fields", valuesCopy);
        },
        [getFieldValue, setFieldValue, fieldsWithExactnessDisabled],
    );
};
